import { Resolver } from 'react-hook-form';
import { ValueOf } from '../../utilities/types';

import conflictFields, { ConflictFields } from '../../constants/conflictFields';

import { organisationNumberValidation } from './fields/OrganizationNumber';

const conflictFieldsValidationMap: Record<ConflictFields, Resolver | undefined> = {
  [conflictFields.ACTIVITIES]: undefined,
  [conflictFields.ADDRESS]: undefined,
  [conflictFields.ALTERNATIVE_BENEFICIAL_OWNERS]: undefined,
  [conflictFields.BENEFICIAL_OWNER]: undefined,
  [conflictFields.BENEFICIAL_OWNERS]: undefined,
  [conflictFields.CITIZENSHIP]: undefined,
  [conflictFields.CITY]: undefined,
  [conflictFields.COMPANY_NAME]: undefined,
  [conflictFields.DATE_OF_BIRTH]: undefined,
  [conflictFields.EMAIL]: undefined,
  [conflictFields.EMPLOYMENT_STATUS]: undefined,
  [conflictFields.FIRST_NAME]: undefined,
  [conflictFields.FORECASTED_TURNOVER]: undefined,
  [conflictFields.INCOME]: undefined,
  [conflictFields.INDUSTRY]: undefined,
  [conflictFields.IS_FINANCIAL_INSTITUTION]: undefined,
  [conflictFields.LAST_NAME]: undefined,
  [conflictFields.LEGAL_FORM]: undefined,
  [conflictFields.LISTED_FINANCIAL_MARKET]: undefined,
  [conflictFields.MIDDLE_NAME]: undefined,
  [conflictFields.MERCHANT_CATEGORY_CODE]: undefined,
  [conflictFields.OPERATION_START_DATE]: undefined,
  [conflictFields.OTHER_LEGAL_FORM]: undefined,
  [conflictFields.OWNER_STRUCTURE]: undefined,
  [conflictFields.PEP]: undefined,
  [conflictFields.PHONE_NUMBER]: undefined,
  [conflictFields.POSTAL_CODE]: undefined,
  [conflictFields.PREVIOUS_TURNOVER]: undefined,
  [conflictFields.PRODUCTS]: undefined,
  [conflictFields.PURPOSE]: undefined,
  [conflictFields.REGISTRATION_NUMBER]: organisationNumberValidation,
  [conflictFields.RESIDENCE]: undefined,
  [conflictFields.ROLE]: undefined,
  [conflictFields.SIGNATORIES]: undefined,
  [conflictFields.SOURCE_OF_FUNDS]: undefined,
  [conflictFields.SOURCE_OF_WEALTH]: undefined,
  [conflictFields.STATE_OWNED]: undefined,
  [conflictFields.TAX_RESIDENCY]: undefined,
  [conflictFields.TIN]: undefined,
  [conflictFields.TRANSACTION_MONITORING_THRESHOLD]: undefined,
  [conflictFields.WEBSITE]: undefined,
} as const;

export type ConflictFieldsValidationMap = ValueOf<typeof conflictFieldsValidationMap>;

export default conflictFieldsValidationMap;
